<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.703 17.5421C18.5245 17.5421 19.1928 16.8673 19.1928 16.0381C19.1928 15.136 18.5714 14.3289 17.703 14.3289V12.9481C18.5714 12.9481 19.1928 12.1409 19.1928 11.2389C19.1928 10.4095 18.5245 9.73488 17.703 9.73488H17.5234C16.1154 9.73488 14.1989 11.9688 13.1205 13.6385C14.1989 15.3084 16.1154 17.5421 17.5234 17.5421H17.703Z"
      fill="currentColor"
    />
    <path
      d="M6.47661 17.5421H6.29694C5.47553 17.5421 4.80723 16.8673 4.80723 16.0381C4.80723 15.136 5.42858 14.3289 6.29694 14.3289V12.9481C5.42858 12.9481 4.80723 12.1409 4.80723 11.2389C4.80723 10.4095 5.47553 9.73488 6.29694 9.73488H6.47661C7.88454 9.73488 9.80106 11.9688 10.8795 13.6385C9.80106 15.3084 7.88454 17.5421 6.47661 17.5421Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 2V5H3C1.34315 5 0 6.34315 0 8V20C0 21.6569 1.34315 23 3 23H21C22.6569 23 24 21.6569 24 20V8C24 6.34315 22.6569 5 21 5H17V2C17 1.44772 16.5523 1 16 1H8C7.44772 1 7 1.44772 7 2ZM9 3V5H15V3H9ZM21 11.2777C21 12.2223 20.6045 13.075 19.9724 13.6748C20.6045 14.2745 21 15.1272 21 16.0718C21 17.879 19.5456 19.3494 17.7579 19.3494H17.5786C15.2573 19.3494 13.0481 16.5569 11.9999 15.0096C10.9519 16.5569 8.74268 19.3494 6.4214 19.3494H6.24215C4.45438 19.3494 3 17.879 3 16.0718C3 15.1272 3.39546 14.2745 4.0276 13.6748C3.39546 13.075 3 12.2223 3 11.2777C3 9.47035 4.45438 8 6.24215 8H6.4214C8.74268 8 10.9519 10.7925 11.9999 12.34C13.0481 10.7925 15.2573 8 17.5786 8H17.7579C19.5456 8 21 9.47035 21 11.2777Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'JobsIconFilled',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
